import 'gridstrap/svg-symbols/mouse-pointer.svg?sprite';
import 'gridstrap/svg-symbols/dollar-sign.svg?sprite';
import 'gridstrap/svg-symbols/circle-star.svg?sprite';
import 'gridstrap/svg-symbols/circle-info.svg?sprite';
import './checkmark.svg';
import './button.scss';

import { components } from 'gridstrap/lib/gs-components';

import { GSButton } from './button';


components.register({
	selector: 'button.gs-Button',
	controller: GSButton
});
